import { ApiError } from './api-error'

export class ApiResponsePayloadError extends ApiError {
  constructor(status: number, message: string, detail?: unknown) {
    super(status, message, detail)
    this.name = 'ApiResponsePayloadError'
  }
}
